import React from "react";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";

const Loader = () => <LoadingAnimation />;

export default Loader;
